__turbopack_context__.v({
  "contacts": "FooterShopInfo-module-scss-module__CVJtAW__contacts",
  "dop": "FooterShopInfo-module-scss-module__CVJtAW__dop",
  "email": "FooterShopInfo-module-scss-module__CVJtAW__email",
  "footerShopInfo": "FooterShopInfo-module-scss-module__CVJtAW__footerShopInfo",
  "phone": "FooterShopInfo-module-scss-module__CVJtAW__phone",
});
